export const CREATE_SESSION_SECTION_LABEL_PROPS = {
  fontWeight: 'normal',
  fontSize: 'md',
  display: {md: 'flex'},
  alignItems: {md: 'center'},
  minH: {md: '48px'},
  minW: {md: '132px'},
};
